import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import island from '../../assets/images/dream/island.svg';
import { RootState } from '../../features';
import { DreamLand } from '../../models/dream/DreamLand';
import { CharacterImage } from '../shared/CharacterImage';
import { FadeInImage } from '../shared/FadeInImage';
import { WaveDivider } from '../shared/WaveDivider';
import { MyIslandDreamText } from './MyIslandDreamText';
interface MyIslandDreamProps {
  dreamLand?: DreamLand;
}

export const MyIslandDream: React.FC<MyIslandDreamProps> = React.memo(({ dreamLand }) => {
  const { t } = useTranslation(['dream', 'translation']);
  const { selectedUserId } = useSelector((state: RootState) => state.user);
  const history = useHistory();
  const handleClick = () => {
    if (dreamLand) {
      history.push('/players/dream/history/my-island-detail');
    }
  };

  return (
    <div
      className={css`
        background: #eae2c7;
        padding: 32px 0 0;
        .content {
          width: 100%;
          max-width: 480px;
          margin: 0 auto;
          padding: 0 20px;

          button {
            display: flex;
            align-items: center;
            background: #f5f1e3;
            font-size: 12px;
            border-radius: 16px;
            color: #938666;
            width: 100%;
            padding: 12px 16px 12px 24px;
            transition: background-color 0.1s;
            &:active {
              background: #ece5d4;
            }
            &:disabled {
              background: none;
            }
          }
        }
        h3 {
          font-size: 14px;
          color: #4d3906;
          width: 100%;
          max-width: 480px;
          margin: 0 0 12px;
        }
        .island-icon {
          position: relative;
        }
        .uploaded-by {
          position: absolute;
          right: 0;
          bottom: 12px;
          width: 30px;
          height: 30px;
          background: #f5f1e3;
          padding: 3px;
          border-radius: 50%;
        }
        button:active .uploaded-by {
          background: #ece5d4;
        }
        .texts {
          flex: 1 1 auto;
          display: flex;
          align-items: flex-start;
          margin: 0 0 0 12px;
          overflow: hidden;
        }
        .empty {
          font-size: 14px;
          color: #4d3906;
        }
        @media (max-width: 369px) {
          .content {
            padding: 0 16px;
            button {
              padding-left: 16px;
            }
          }
          .texts {
            font-size: 11px;
          }
          .landname {
            font-size: 16px;
          }
        }
      `}
    >
      <div className="content">
        <h3>{t('my_islands_dream')}</h3>
        <button disabled={!dreamLand} onClick={handleClick}>
          <div className="island-icon">
            <FadeInImage
              src={island}
              ariaHidden={true}
              style={{ width: '48px', height: '104px' }}
            />
            {dreamLand && (
              <div className="uploaded-by">
                <CharacterImage
                  src={dreamLand.uploadUser.image}
                  isPlayer={true}
                  isReported={
                    dreamLand.uploadUser.screening === 'ng' &&
                    dreamLand.uploadUser.id !== selectedUserId
                  }
                />
              </div>
            )}
          </div>
          <div className="texts">
            {dreamLand ? (
              <MyIslandDreamText dreamLand={dreamLand} />
            ) : (
              <div className="empty">{t('empty_dream')}</div>
            )}
          </div>
        </button>
      </div>
      <WaveDivider color1={'#eee8d3'} color2={'#eae2c7'} />
    </div>
  );
});
